module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FR1rIL/tc-custom/9781788855785.jpg?1734635810625",
      "alt": "This image is the cover for the book Far Field"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Far Field\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Far Field is the third and final book in The Auchensale Trilogy, a series of poetry cycles capturing the changing rural landscape of the West of Scotland. Following on from its predecessors Black Cart and Bale Fire, the book consists of three cycles bound together by footers.  A number of poems in the early part of the book are in response to paintings by the Glasgow Boys particularly those painted during their time spent in agricultural communities. Many of the poems are highly personal with a number about family members. These include a series of elegies for his late father. It also focuses on the present day looking to the challenges ahead for the family farm and that passing baton to the next generation.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jim Carruth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jim Carruth was born in Johnstone, Renfrewshire, and grew up on his family’s farm near Kilbarchan. His first chapbook collection Bovine Pastoral was published in 2004. Since then he has brought out a further five chapbooks and an illustrated fable. He has won both the James McCash poetry competition and the McLellan Poetry Prize and was awarded a Robert Louis Stevenson Fellowship in 2009. He was chosen as one of the poets showcased in Oxford Poets 2010. In 2014 he was appointed Poet Laureate of Glasgow.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Polygon\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0